'use client';
const reactMapper = {
  tabindex: "tabIndex",
  class: "className",
  for: "htmlFor",
  readonly: "readOnly"
};
const skippedProperties = ["selected"];
function normalizeProps(props) {
  const normalizedProps = {};
  Object.keys(props).forEach((propKey) => {
    if (skippedProperties.includes(propKey)) return;
    const inMapper = Object.keys(reactMapper).includes(propKey);
    if (inMapper) {
      normalizedProps[reactMapper[propKey]] = props[propKey];
    } else {
      normalizedProps[propKey] = props[propKey];
    }
  });
  return normalizedProps;
}

export { normalizeProps };
